const Subscriptions = () => {

    const categoryItems = document.getElementsByClassName('new-subscription__categories-items-item');
    const productsRows = document.getElementsByClassName('new-subscription__products-items-item');
    const ProductsItems = document.getElementsByClassName('new-subscription__products-items-item-product');
    const packageTypeBtns = document.getElementsByClassName('new-subscription__package-type-items-item');
    const packagesRows = document.getElementsByClassName('packages-row-js');
    const packagesItems = document.getElementsByClassName('packages-item-js');
    const numberPopup   = document.getElementsByClassName('new-subscription__popup')[0];
    const categoryBottom = document.getElementsByClassName('new-subscription__info-categories-item');
    const rowsBottom     = document.getElementsByClassName('package-row-bottom-js');
    const showMoreBtn    = document.getElementsByClassName('packages-item__more');
    const showLessBtn    = document.getElementsByClassName('packages-item__less');
    const productsWrapper = document.getElementsByClassName('new-subscription__products')[0];

    if(showMoreBtn) {
        for(var i = 0; i < showMoreBtn.length; i++) {
            showMoreBtn[i].addEventListener('click', function() {
                let lessBtnItem = this.parentNode.getElementsByClassName('packages-item__less')[0];
                let listOfItems = this.parentNode.getElementsByClassName('packages-item__more-list')[0];
                this.classList.add('hidden');

                if(lessBtnItem) {
                    lessBtnItem.classList.remove('hidden');
                }

                if(listOfItems) {
                    listOfItems.classList.add('active');
                }
            })
        }
    }

    if(showLessBtn) {
        for(var i = 0; i < showLessBtn.length; i++) {
            showLessBtn[i].addEventListener('click', function() {
                let moreBtnItem = this.parentNode.getElementsByClassName('packages-item__more')[0];
                let listOfItems = this.parentNode.getElementsByClassName('packages-item__more-list')[0];
                this.classList.add('hidden');

                if(moreBtnItem) {
                    moreBtnItem.classList.remove('hidden');
                }

                if(listOfItems) {
                    listOfItems.classList.remove('active');
                }
            })
        }
    }


    if(categoryBottom) {
        for(var i = 0; i < categoryBottom.length; i++) {
            categoryBottom[i].addEventListener('click',function() {
                let bottomProductType = this.dataset.infoType;
                
                for(var i = 0; i < categoryBottom.length; i++) {

                    categoryBottom[i].classList.remove('active');
                    this.classList.add('active');

                    for(var j = 0; j < rowsBottom.length; j++) {
                        rowsBottom[j].classList.remove('active');

                        if(bottomProductType === rowsBottom[j].dataset.infoType) {
                            rowsBottom[j].classList.add('active');
                        }
                    }
                }
            })
        }
    }

    if(categoryItems) {
        for(var i = 0; i < categoryItems.length; i++) {
            categoryItems[i].addEventListener('click', function() {
                let categoryItemsType = this.dataset.subscribeType;

                for(var j =0; j < categoryItems.length; j++) {
                    categoryItems[j].classList.remove('active');
                }

                this.classList.add('active');

                if(productsRows) {
                    for(var i = 0; i < productsRows.length; i++) {
                        productsRows[i].classList.remove('active');
                    }

                    for(var i = 0; i < productsRows.length; i++) {

                        if(productsRows[i].dataset.subscribeType == categoryItemsType) {
                            let firstElement = productsRows[i].firstElementChild;

                            productsRows[i].classList.add('active');

                            for(var j =0; j < ProductsItems.length; j++) {
                                ProductsItems[j].classList.remove('active');
                            }

                            firstElement.classList.add('active');

                            if(packagesRows) {
                                for(var i = 0; i < packagesRows.length; i++) {
                                    packagesRows[i].classList.remove('active');
                                    
                                    if(firstElement.dataset.subscribeProductType === packagesRows[i].dataset.packagesType) {
                                        packagesRows[i].classList.add('active');
                                    }
                                }
                            }
                        }
                    }
                }
                showTeleOrNo();
            })
        }
    }

    if(ProductsItems) {
        for(var i = 0; i < ProductsItems.length; i++) {
            ProductsItems[i].addEventListener('click',function() {
                for(var j =0; j < ProductsItems.length; j++) {
                    ProductsItems[j].classList.remove('active');
                }

                let productType = this.dataset.subscribeProductType;
                this.classList.add('active');

                if(packagesRows) {
                    for(var i = 0; i < packagesRows.length; i++) {

                        packagesRows[i].classList.remove('active');

                        if(packagesRows[i].dataset.packagesType === productType) {
                            packagesRows[i].classList.add('active');
                        }
                    }
                }
                showTeleOrNo();
            })
        }
    }

    if(packageTypeBtns) {
        for(var i = 0; i < packageTypeBtns.length; i++) {
            packageTypeBtns[i].addEventListener('click',function() {
                for(var j =0; j < packageTypeBtns.length; j++) {
                    packageTypeBtns[j].classList.remove('active');
                }

                let productType = this.dataset.subscribeProductType;
                this.classList.add('active');

                if(packagesRows) {
                    for(var i = 0; i < packagesRows.length; i++) {

                        packagesRows[i].classList.remove('active');

                        if(packagesRows[i].dataset.packagesType === productType) {
                            packagesRows[i].classList.add('active');
                            packagesRows[i].classList.remove('d-none');
                        }
                    }
                }
                showTeleOrNo();
            })
        }
    }

    if(packagesItems) {
        for(var i = 0; i < packagesItems.length; i++) {
            packagesItems[i].addEventListener('click',function() {
                if(this.dataset.packagesId === 'cyclic') {
                    if(numberPopup) {
                        numberPopup.classList.add('active');
                    }
                } else {
                    
                    let packagesId = this.dataset.packagesId;
                    console.log(packagesId);
                    
                }
            })
        }
    }

    if(numberPopup) {
        numberPopup.addEventListener('click', function(el) {
            // Removed from if: || el.target.classList.contains('new-subscription__popup-wrapper-form-button')
            if(el.target.classList.contains('new-subscription__popup')) {
                numberPopup.classList.remove('active')
            }

        })
    }


    function showTeleOrNo() {

        const activeProductItem = document.querySelector('.new-subscription__products-items-item.active .new-subscription__products-items-item-product.active');
        const activePackageType = document.querySelector('.new-subscription__package-type-items-item.active');
        const telePackageRow    = document.querySelector('.package-tele-row-js');

        if(activeProductItem) {
            console.log(activeProductItem);
            if(activeProductItem.dataset.linkType == 'bs04' || activeProductItem.dataset.linkType == 'bs03') {
                if(productsWrapper) {
                    productsWrapper.classList.add('bs-tele-active');
                }
                if(activePackageType) {
                    if(activePackageType.dataset.linkType === 'bs04to') {
                        for(var i = 0; i < packagesRows.length; i++) {
                            packagesRows[i].classList.remove('active');
                            // packagesRows[i].classList.add('d-none');
                        }
                        telePackageRow.classList.add('active');
                        telePackageRow.classList.remove('d-none');
                    }
                }
            } else {
                if(productsWrapper) {
                    productsWrapper.classList.remove('bs-tele-active');
                }
            }
        }

    }



    // Detect device type from link

    var url_string = window.location.href;
    var url = new URL(url_string);
    var linkParam = url.searchParams.get("type");

    if(linkParam) {
        if(categoryItems) {
            for(var i = 0; i < categoryItems.length; i++) {
                if(categoryItems[i].dataset.linkType) {
                    let linkType = categoryItems[i].dataset.linkType;
                    if(linkType.includes(linkParam)) {
                        categoryItems[i].classList.add('active');
                    } else {
                        categoryItems[i].classList.add('d-none');
                    }
                } else {
                    productsRows[i].classList.add('d-none');
                }
            }
        }
    
        if(productsRows) {
            for(var i = 0; i < productsRows.length; i++) {
                if(productsRows[i].dataset.linkType) {
                    let linkType = productsRows[i].dataset.linkType;
                    if(linkType.includes(linkParam)) {
                        productsRows[i].classList.add('active');
                    } else {
                        productsRows[i].classList.add('d-none');
                    }
                } else {
                    productsRows[i].classList.add('d-none');
                }
            }
        }
    
        if(ProductsItems) {
            for(var i = 0; i < ProductsItems.length; i++) {
                if(ProductsItems[i].dataset.linkType) {
                    let linkType = ProductsItems[i].dataset.linkType;
                    if(linkType === linkParam) {
                        ProductsItems[i].classList.add('active');
                        if(linkParam == 'bs03' || linkParam == 'bs04') {
                            displayTeleChoice();
                        }
                    } else if(linkType == 'bs04' && linkParam == 'bs04to') {
                        ProductsItems[i].classList.add('active');
                        addActiveClassToBsWhenTypeInLink();
                    } else if(linkType == 'bs03' && linkParam == 'bs03to') {
                        ProductsItems[i].classList.add('active');
                        addActiveClassToBsWhenTypeInLink();
                    } else {
                        ProductsItems[i].classList.remove('active');
                        ProductsItems[i].classList.add('d-none');
                    }
                } else {
                    productsRows[i].classList.add('d-none');
                }
            }
        }

        if(packagesRows) {
            for(var i = 0; i < packagesRows.length; i++) {
                if(packagesRows[i].dataset.linkType) {
                    let linkType = packagesRows[i].dataset.linkType;
                    if(linkType === linkParam) {
                        packagesRows[i].classList.add('active');
                    } else {
                        packagesRows[i].classList.add('d-none');
                    }
                } else {
                    productsRows[i].classList.add('d-none');
                }
            }
        }
    }

    function addActiveClassToBsWhenTypeInLink() {
        productsWrapper.classList.add('bs-tele-active');
        packageTypeBtns[0].classList.add('active');
        packageTypeBtns[1].classList.remove('active');
        packageTypeBtns[1].classList.add('d-none');
    }

    function displayTeleChoice() {
        productsWrapper.classList.add('bs-tele-active');
    }



}

export default Subscriptions;